import { render, staticRenderFns } from "./DeleteUserModal.vue?vue&type=template&id=676f8244&scoped=true"
import script from "./DeleteUserModal.vue?vue&type=script&lang=js"
export * from "./DeleteUserModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteUserModal.vue?vue&type=style&index=0&id=676f8244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f8244",
  null
  
)

export default component.exports